import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { MemoEditDialogContext, MemoEditDialogInitialState } from ".";

export const MemoEditDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(MemoEditDialogInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <MemoEditDialogContext.Provider value={context}>
      {children}
    </MemoEditDialogContext.Provider>
  );
};
